<template>
  <v-container class="mt-5">
    <!-- head -->
    <v-row justify="center">
      <!-- title -->
      <v-col class="pb-0">
        <base-title no-margin-top>Users</base-title>
        <p class="primary--text text-caption">
          <router-link to="/users" style="text-decoration: none;">
            User Base
          </router-link>
          <span class="grey--text text--darken-2">
            <span class="mx-1">></span>
            {{ edit ? name : 'Add User' }}
          </span>
        </p>
      </v-col>
      <!-- search field -->
      <!-- <v-col cols="3">
        <v-text-field
          dense
          rounded
          outlined
          prepend-inner-icon="mdi-magnify"
          placeholder="Search"
        ></v-text-field>
      </v-col> -->
    </v-row>

    <!-- form -->
    <user-form></user-form>
  </v-container>
</template>

<script>
  export default {
    name: "UserDetail",

    components: {
      UserForm: () => import('./UserForm.vue')
    },

    created() {
      if (this.$route.params.id != 'add') {
        this.$store.dispatch('user/fetchUser', {set_fields: true, id: this.$route.params.id})
      }
    },

    computed: {
      edit() { return this.$route.params.id !== 'add' ? true : false },
      name() { return this.$store.getters['user/displayName'] }
    },

    beforeDestroy() {
      this.$store.commit('user/clearFields')
    }
  }
</script>

<style lang="scss" scoped>

</style>